<template>
        <a-modal
                title="请输入废止原因"
                okText="确认"
                cancelText="取消"
                width="500px"
                :visible="visible"
                :confirm-loading="confirmLoading"
                @ok="handleOk"
                @cancel="handleCancel"
        >
            <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{span:0}" :wrapper-col="{span:24}">
                <a-form-model-item  prop="jieguo">
                    <a-textarea  placeholder="请输入废止原因" autocomplete="off" v-model="form.jieguo" />
                </a-form-model-item>
            </a-form-model>
    </a-modal>
</template>

<script>

    export default {
        name: "FormModel",
        props:{
            visible:{
                type:Boolean,
                default:false
            },
            param:{
                type:Object,
                default: ()=>{
                    return {}
                }
            }
        },
        data() {
            return {
                confirmLoading: false,
                form:{
                    jieguo:'',
                },
                rules:{
                    jieguo:[{ required: true, message: '请输入文本框内容', trigger: 'blur' },],
                },
            };
        },
        created(){
            this.initForm();
        },
        methods: {
            initForm(){
                this.form.jieguo=this.param.jielun;
            },
            handleOk(e) {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        //TODO: 返回值
                        this.$emit("update:visible",false)
                        this.$emit("dialogBack",{record:this.param.record,jieguo:this.form.jieguo});
                    } else {
                        return false;
                    }
                });
            },
            handleCancel(e) {
                this.$emit("update:visible",false)
            },
        },
    }
</script>

<style scoped lang="scss">

    /*/deep/ .ant-modal-body{*/
        /*height: 70vh;*/
        /*overflow-y: scroll;*/
    /*}*/

</style>